const PrivacyPolicySubjects = {
  COMPLETED_TRAILS: 'completedTrails',
  ACTIVITIES: 'activities',
  ACTIVITY: 'activity',
  CUSTOM_MAPS: 'customMaps',
  CUSTOM_MAP: 'customMap',
  LISTS: 'lists',
  SOCIAL_NETWORK: 'socialNetwork',
  FOLLOW_REQUESTS_REQUIRED: 'followRequestsRequired',
  CUSTOM_ROUTE: 'customRoute',
  CUSTOM_ROUTES: 'customRoutes',
  LIST: 'list'
};

type PrivacyPolicySubjects = (typeof PrivacyPolicySubjects)[keyof typeof PrivacyPolicySubjects];

export { PrivacyPolicySubjects };
